import { z } from 'zod';
import { IDSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
/**
 * knowledge-upload — API schemas for admin-managed RAG knowledge documents.
 * Source of truth for the backend route (OpenAPI) and the CRM admin frontend.
 *
 * NOTE: the large `rawText` column is NOT part of the API view — list/detail
 * return metadata only. Like `document_embeddings`, this entity is exempt from
 * ci/zod-drizzle-drift (AI-infra precedent); the Drizzle table is the storage
 * source of truth and this schema is the API contract.
 */
/** Coarse RBAC tag propagated to the embedding chunks. */
export const KnowledgeVisibilitySchema = z.enum(['staff']);
export const KnowledgeDocumentStatusSchema = z.enum([
    'active',
    'pending_embedding',
    'failed',
]);
/** API representation of a knowledge document (metadata only — no rawText). */
export const KnowledgeDocumentSchema = z.object({
    id: IDSchema,
    type: z.literal('knowledge_document'),
    schemaVersion: SchemaVersionSchema,
    title: z.string(),
    filename: z.string(),
    contentType: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    visibility: KnowledgeVisibilitySchema,
    status: KnowledgeDocumentStatusSchema,
    chunkCount: z.number().int().nonnegative(),
    lastError: z.string().nullable().optional(),
    uploadedByEmail: z.string(),
    createdAt: IsoTimestampSchema,
    updatedAt: IsoTimestampSchema,
});
export const KnowledgeDocumentListResponseSchema = z.object({
    documents: z.array(KnowledgeDocumentSchema),
    totalChunks: z.number().int().nonnegative(),
});
/**
 * Multipart upload metadata fields (sent alongside the binary `file` part).
 * `title` is optional — the route falls back to the filename when omitted.
 */
export const KnowledgeUploadMetaSchema = z.object({
    title: z.string().min(1).max(300).optional(),
    visibility: KnowledgeVisibilitySchema.optional(),
});
//# sourceMappingURL=knowledge-document.js.map